import React from "react";

export const AccountsSkeleton: React.FC = () => {
  return (
    <div className="w-full max-w-full mx-auto  py-2.5 flex flex-col gap-y-3">
      <style>{`
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        .sk {
          background: linear-gradient(
            90deg,
      #ddd6fe 25%,
      #c4b5fd 50%,
      #ddd6fe 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
          display: block;
        }

        .sk-section {
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          padding: 12px;
          margin-bottom: 8px;
        }

        .sk-section-title {
          height: 20px;
          width: 200px;
          margin-bottom: 12px;
        }

        .sk-section-desc {
          height: 14px;
          width: 100%;
          max-width: 300px;
          margin-bottom: 12px;
        }

        .sk-select {
          height: 40px;
          width: 100%;
          border-radius: 6px;
        }

        /* Responsive adjustments */
        @media (max-width: 640px) {
          .sk-section {
          bg: blue-50 border border: blue-200 
            padding: 10px 8px;
            margin-bottom: 6px;
          }

          .sk-section-title {
            width: 150px;
            height: 18px;
          }

          .sk-section-desc {
            max-width: 100%;
            height: 12px;
          }

          .sk-select {
            height: 36px;
          }
        }

        @media (min-width: 641px) and (max-width: 768px) {
          .sk-section {
            padding: 12px;
            margin-bottom: 8px;
          }

          .sk-select {
            height: 38px;
          }
        }
      `}</style>

      <div className="flex flex-col gap-y-3">
        

        <div className="p-2 bg-blue-50 border border-blue-200 rounded-md">
          <div className="sk h-4 sm:h-5 w-32 sm:w-48"></div>
        </div>
      </div>

      <div className="flex flex-col gap-y-3 mb-2">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="flex flex-row sm:flex-row sm:items-center gap-3 sm:gap-2 justify-between p-3 sm:p-4 bg-white border border-gray-200 rounded-md"
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full sk flex-shrink-0"></div>

              <div className="flex-1 min-w-0">
                <div className="sk h-4 sm:h-5 w-24 sm:w-32 mb-2"></div>
                <div className="sk h-3.5 sm:h-4 w-20 sm:w-24"></div>
              </div>
            </div>
            <div className="w-auto justify-end sm:w-auto flex sm:justify-end flex-shrink-0">
              <div className="sk h-8 w-full sm:w-24 rounded-md"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Page Selection Sections Skeleton */}
      <div className="flex flex-col gap-y-3">
        {/* Facebook Page Selection */}
        <div className="sk-section">
          <div className="sk sk-section-title"></div>
          <div className="sk sk-section-desc"></div>
          <div className="sk sk-select"></div>
        </div>

        {/* LinkedIn Page Selection */}
        <div className="sk-section">
          <div className="sk sk-section-title"></div>
          <div className="sk sk-section-desc"></div>
          <div className="sk sk-select"></div>
        </div>

        {/* YouTube Channel Selection */}
        <div className="sk-section">
          <div className="sk sk-section-title"></div>
          <div className="sk sk-section-desc"></div>
          <div className="sk sk-select"></div>
        </div>
      </div>
    </div>
  );
};
